import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { authService } from "../services/auth";
import Captcha from "../components/Captcha";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!captchaVerified) {
      setError("Por favor, complete a verificação de segurança");
      return;
    }

    setLoading(true);

    try {
      await authService.login(email, password);
      navigate("/portfolio");
    } catch (err) {
      setError(err.message || "Erro ao fazer login. Verifique suas credenciais.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: "500px", margin: "4rem auto" }}>
      <div className="panel" style={{ padding: "3rem" }}>
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <img
            src={logo}
            alt="Sistema Único - Imobiliárias"
            style={{ width: "450px", height: "auto", marginBottom: "1.5rem" }}
          />
          <h1 style={{ marginBottom: "0.5rem" }}>Entrar</h1>
          <p style={{ color: "var(--text-secondary)" }}>
            Acesse sua conta no Sistema Único - Imobiliárias
          </p>
        </div>

        {error && (
          <div
            style={{
              padding: "1rem",
              background: "#fee",
              border: "1px solid #fcc",
              borderRadius: "var(--radius-md)",
              color: "#c33",
              marginBottom: "1.5rem",
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "1.5rem" }}>
            <label htmlFor="email" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-md)",
                fontSize: "1rem",
              }}
              placeholder="seu@email.com"
            />
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <label htmlFor="password" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
              Senha
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-md)",
                fontSize: "1rem",
              }}
              placeholder="••••••••"
            />
          </div>

          <Captcha onVerify={setCaptchaVerified} />

          <button
            type="submit"
            className="btn-primary"
            disabled={loading || !captchaVerified}
            style={{ width: "100%", marginTop: "1.5rem", marginBottom: "1rem" }}
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
          <p style={{ color: "var(--text-secondary)" }}>
            Não tem uma conta?{" "}
            <Link to="/register" style={{ color: "var(--brand-blue)", fontWeight: 500 }}>
              Cadastre-se
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
